import { Injectable } from '@angular/core';
import { Representation } from '@services/api-client/responses/login-response.type';
import { SessionStorageKey, SessionStorageService } from '@services/session-storage';
import { Permission, RepresentationType } from 'app/enums';
import { AuthenticatedUser } from 'app/types';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    public userPermissions: Permission[] = [];
    public representing: Representation;

    public constructor(private readonly sessionStorageService: SessionStorageService) {
        this.loadUserPermissions();
    }

    private loadUserPermissions() {
        const user = this.sessionStorageService.getItem<AuthenticatedUser>(SessionStorageKey.User);
        this.userPermissions = user ? user.permissions : [];
        this.representing = user ? user.representing : null;
    }

    public setUserPermissions() {
        this.loadUserPermissions();
    }

    public hasPermissions(permissions: Permission[]) {
        return permissions.length ? permissions.every((p) => this.userPermissions.includes(p)) : true;
    }

    public hasAnyPermission(permissions: Permission[]) {
        return permissions.length ? permissions.some((p) => this.userPermissions.includes(p)) : true;
    }

    public isUnrestricted() {
        return this.representing?.representationType === RepresentationType.UnRestricted;
    }

    public isPrivateTenant() {
        return this.representing.isPrivate;
    }
}
